import { render, staticRenderFns } from "./menu-day-chart.vue?vue&type=template&id=122514e8&"
import script from "./menu-day-chart.vue?vue&type=script&lang=js&"
export * from "./menu-day-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports